import Ps from "perfect-scrollbar";

class SearchFilters {
  constructor(context, settings, $) {
    // Environment variables
    this.$ = $;

    // Document
    this.$window = this.$(window);

    // Elements
    this.$filterItems = this.$(".js-search-filter-items").once();

    const $caseStudyCheckbox = document.querySelector('[value="case_study"]');
    const filterCheckboxes = document.querySelectorAll(
      ".c-search-filters__item-checkbox"
    );

    filterCheckboxes.forEach((filterCheckbox) => {
      filterCheckbox.addEventListener("click", () =>
        this.setModalCheckbox(filterCheckbox.checked, filterCheckbox.id)
      );
    });

    
    const filters = Array.from(document.querySelectorAll('.c-search-filters__filter'));
    filters.map(filter => {
      const checkedCheckboxes = filter.querySelectorAll('input:checked');
      if (checkedCheckboxes.length > 0) {
        const filterButton = filter.querySelector('button');
        if(filterButton){
          this.toggleFilters(filterButton);
        }
      }
    });

    const $selectAllCheckboxes = document.querySelectorAll(
      ".c-search-filters__select-all-checkbox"
    );
    if ($selectAllCheckboxes) {
      $selectAllCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", () => {
          if (checkbox.checked) {
            this.selectAll(checkbox.parentNode.parentNode.id);
            return;
          }

          this.clearFilterCheckBoxes(checkbox.parentNode.parentNode.id);
        });
      });
    }


    if ($caseStudyCheckbox) {
      $caseStudyCheckbox.addEventListener("change", (e) => {
        if ($caseStudyCheckbox.checked) {
          this.showRegionFilter();
        } else {
          this.hideRegionFilter();
          this.clearFilterCheckBoxes("filters-region");
        }
      });
    }

    if ($caseStudyCheckbox && !$caseStudyCheckbox.checked) {
      this.hideRegionFilter();
    }

    this.checkFilterLabel();

    // Scrollbars
    //----------------------------------------
    this.scrollbars = [];

    if (!this.$("html").hasClass("no-classlist")) {
      this.addScrollbars();
      // // On load init the scrollbars
      this.$window.on("load", this.$.proxy(this.addScrollbars, this));

      this.$window.on("resize", this.$.proxy(this.updateScrollbars, this));
    }

    // Events
    //----------------------------------------
    this.$("body")
      .unbind("click")
      .on("click", ".js-search-filter-header", (e) => {
        e.preventDefault();
        this.toggleFilters(e.currentTarget);

        if (!this.$("html").hasClass("no-classlist")) {
          this.addScrollbars();
        }
      });
  }

  hideRegionFilter() {
    const regionButton = document.querySelector("#btn-region");
    if (regionButton) {
      regionButton.parentNode.classList.add("is-hidden");
    }
  }

  showRegionFilter() {
    const regionButton = document.querySelector("#btn-region");
    if (regionButton) {
      regionButton.parentNode.classList.remove("is-hidden");
    }
  }

  clearFilterCheckBoxes(filterId) {
    const filterLists = document.querySelectorAll(`#${filterId}`);
    filterLists.forEach((filterList) => {
      if (filterList) {
        const checkboxes = filterList.querySelectorAll("input[type=checkbox]");
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });
      }
    });
  }

  selectAll(filterId) {
    const filterLists = document.querySelectorAll(`#${filterId}`);
    filterLists.forEach((filterList) => {
      if (filterList) {
        const checkboxes = filterList.querySelectorAll("input[type=checkbox]");
        checkboxes.forEach((checkbox) => {
          checkbox.checked = true;
        });
      }
    });
  }

  setModalCheckbox(checked, id) {
    const modalFiltersCheckbox = document.querySelector(
      `.c-search-modal-filters__item-checkbox[data-mapped-id=${id}]`
    );
    modalFiltersCheckbox.checked = checked;
  }

  checkFilterLabel() {
    const labels = document.getElementsByClassName("c-filters__item-label");
    for (const label of labels) {
      const labelContent = label.innerText.trim();
      if (labelContent === "Case Study") {
        label.addEventListener("click", () => {
          const buttons = document.getElementsByClassName(
            "js-search-filter-header"
          );

          if (buttons.length > 0) {
            for (const button of buttons) {
              const filterButtonText = button.innerText.trim();
              const buttonParent = button.parentNode;
              const isHidden = buttonParent.classList.contains("is-hidden");

              if (isHidden) {
                buttonParent.classList.remove("is-hidden");
              } else {
                if (!isHidden && filterButtonText === "Region") {
                  buttonParent.classList.add("is-hidden");
                }
              }
            }
          }
        });
      }
    }
  }


  toggleFilters(element) {
    const $elem = this.$(element);

    $elem
      .next()
      .slideToggle(300, () => {
        if (!this.$("html").hasClass("no-classlist")) {
          this.updateScrollbars();
        }
      })
      .toggleClass("is-open");

    $elem.toggleClass("is-clicked");

    if ($elem.hasClass("is-clicked")) {
      $elem.attr("aria-expanded", "true");
    } else {
      $elem.attr("aria-expanded", "false");
    }
  }

  addScrollbars() {
    this.$filterItems = this.$(".js-search-filter-items");
    for (let i = 0; i < this.$filterItems.length; i++) {
      this.scrollbars.push(new Ps(this.$filterItems[i]));
    }
  }

  updateScrollbars() {
    this.scrollbars.forEach((ps) => ps.update());
  }
}

export default SearchFilters;
